/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const BookPageSizeEnum = Object.freeze({
	A3: "A3",
	A4: "A4",
	A5: "A5",
	LETTER: "LETTER",
	LEGAL: "LEGAL",
	TABLOID: "TABLOID",
})

export const bookPageSizeOptions = Object.freeze([
	{value: BookPageSizeEnum.A3, label: "A3"},
	{value: BookPageSizeEnum.A4, label: "A4"},
	{value: BookPageSizeEnum.A5, label: "A5"},
	{value: BookPageSizeEnum.LETTER, label: "Letter"},
	{value: BookPageSizeEnum.LEGAL, label: "Legal"},
	{value: BookPageSizeEnum.TABLOID, label: "Tabloid"},
])
